import { PublisherCampaignRequiredFieldsConfig } from 'components/common/types/Publisher.types';

const DEFAULT_REQUIRED_DIRECT_SALES_CAMPAIGN_FIELDS = ['advertiser', 'brand', 'productCategory'];

export const isRequiredDirectSalesField = ({
  fieldsConfig,
  fieldName,
}: {
  fieldsConfig?: PublisherCampaignRequiredFieldsConfig;
  fieldName: string;
}): boolean => {
  if (!fieldsConfig?.campaign) return DEFAULT_REQUIRED_DIRECT_SALES_CAMPAIGN_FIELDS.includes(fieldName) ?? false;

  return fieldsConfig.campaign.includes(fieldName) ?? false;
};
